import { SerializableObject } from '../../common-react/core';


export class RefundRequest extends SerializableObject {
    public IdentifcationNumber: string;
    public AccountNumber: string;
    public AccountBank: string;
    public AccountType: string;
    public AccountIdentificationNumber: string;
}
